const BURN_UP_CUTOFF = '2022-03-14';

export default BURN_UP_CUTOFF;
